import { useSlate } from 'slate-react';

import { Editor } from 'slate';

import Box from '../Box/Box.jsx';
import ToggleButton from '../ToggleButton/ToggleButton.jsx';
import ToggleButtonGroup from '../ToggleButtonGroup/ToggleButtonGroup.jsx';
import { editorControlButtons } from './TextAreaWithControls.utils.jsx';

const FormatButtonControls = ({ isDisabled }: { isDisabled: boolean }) => {
  const editor = useSlate();

  const isMarkActive = (format: string) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format as keyof typeof marks] === true : false;
  };

  const toggleMark = (mark: 'bold' | 'italic') => () => {
    const isActive = isMarkActive(mark);
    if (isActive) {
      Editor.removeMark(editor, mark);
    } else {
      Editor.addMark(editor, mark, true);
    }
  };

  return (
    <Box sx={{ backgroundColor: 'palette.ui.primary' }}>
      <ToggleButtonGroup disabled={isDisabled}>
        {editorControlButtons.map(({ role, value: formatValue, icon }) => {
          switch (role) {
            case 'markButton': {
              return (
                <ToggleButton
                  key={formatValue}
                  value=""
                  selected={isMarkActive(formatValue)}
                  disabled={isDisabled}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMark(formatValue as 'bold' | 'italic')();
                  }}
                  icon={icon}
                />
              );
            }
            default:
              return null;
          }
        })}
      </ToggleButtonGroup>
    </Box>
  );
};

export default FormatButtonControls;
